/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScriptSection } from './ScriptSection.js';
import {
    ScriptSectionFromJSON,
    ScriptSectionFromJSONTyped,
    ScriptSectionToJSON,
} from './ScriptSection.js';

/**
 * 
 * @export
 * @interface ContactScript
 */
export interface ContactScript {
    /**
     * 
     * @type {string}
     * @memberof ContactScript
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ContactScript
     */
    chapterCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactScript
     */
    currentChapter?: number;
    /**
     * 
     * @type {Array<ScriptSection>}
     * @memberof ContactScript
     */
    chapters?: Array<ScriptSection>;
}

/**
 * Check if a given object implements the ContactScript interface.
 */
export function instanceOfContactScript(value: object): boolean {
    return true;
}

export function ContactScriptFromJSON(json: any): ContactScript {
    return ContactScriptFromJSONTyped(json, false);
}

export function ContactScriptFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactScript {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'chapterCount': json['chapterCount'] == null ? undefined : json['chapterCount'],
        'currentChapter': json['currentChapter'] == null ? undefined : json['currentChapter'],
        'chapters': json['chapters'] == null ? undefined : ((json['chapters'] as Array<any>).map(ScriptSectionFromJSON)),
    };
}

export function ContactScriptToJSON(value?: ContactScript | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'chapterCount': value['chapterCount'],
        'currentChapter': value['currentChapter'],
        'chapters': value['chapters'] == null ? undefined : ((value['chapters'] as Array<any>).map(ScriptSectionToJSON)),
    };
}

